import React from 'react';

interface IContactProps {
    children: any
    value: string
    type: 'email' | 'phone'
}

const types = {
    email: (value: string) => `mailto:${value}`,
    phone: (value: string) => `tel:${value}`
};

function Contact({ children, value, type }: IContactProps) {
    return (
        <a href={types[type](value)}>
            {children}
        </a>
    );
}

export default Contact;
